import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "min-h-full" }
const _hoisted_2 = { class: "p-4" }
const _hoisted_3 = { class: "border-b border-gray-200" }
const _hoisted_4 = {
  class: "-mb-px flex",
  "aria-label": "Tabs"
}
const _hoisted_5 = { class: "space-y-6" }
const _hoisted_6 = {
  key: 0,
  class: "mt-4 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6"
}
const _hoisted_7 = { class: "md:grid md:grid-cols-3 md:gap-6" }
const _hoisted_8 = { class: "mt-5 md:mt-0 md:col-span-2" }
const _hoisted_9 = { class: "mt-1 flex items-center space-x-5" }
const _hoisted_10 = {
  key: 0,
  class: "inline-block h-12 w-12 rounded-full overflow-hidden bg-gray-100"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-full w-full text-gray-300",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" })
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "grid grid-cols-6 gap-6" }
const _hoisted_15 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "first-name",
  class: "block text-sm font-medium text-gray-700"
}, "俗名苗字", -1)
const _hoisted_17 = {
  key: 0,
  class: "text-xs text-pink-600"
}
const _hoisted_18 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "last-name",
  class: "block text-sm font-medium text-gray-700"
}, "俗名名前", -1)
const _hoisted_20 = {
  key: 0,
  class: "text-xs text-pink-600"
}
const _hoisted_21 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  for: "first-name",
  class: "block text-sm font-medium text-gray-700"
}, "俗名苗字カナ", -1)
const _hoisted_23 = {
  key: 0,
  class: "text-xs text-pink-600"
}
const _hoisted_24 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  for: "last-name",
  class: "block text-sm font-medium text-gray-700"
}, "俗名名前カナ", -1)
const _hoisted_26 = {
  key: 0,
  class: "text-xs text-pink-600"
}
const _hoisted_27 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  for: "last-name",
  class: "block text-sm font-medium text-gray-700"
}, "ニックネーム", -1)
const _hoisted_29 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_30 = { class: "col-span-4 flex flex-col" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "block px-2 text-sm font-medium text-gray-700" }, "生年月日", -1)
const _hoisted_32 = { class: "flex items-center" }
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<option></option><option>01</option><option>02</option><option>03</option><option>04</option><option>05</option><option>06</option><option>07</option><option>08</option><option>09</option><option>10</option><option>11</option><option>12</option>", 13)
const _hoisted_46 = [
  _hoisted_33
]
const _hoisted_47 = /*#__PURE__*/_createStaticVNode("<option></option><option>01</option><option>02</option><option>03</option><option>04</option><option>05</option><option>06</option><option>07</option><option>08</option><option>09</option><option>10</option><option>11</option><option>12</option><option>13</option><option>14</option><option>15</option><option>16</option><option>17</option><option>18</option><option>19</option><option>20</option><option>21</option><option>22</option><option>23</option><option>24</option><option>25</option><option>26</option><option>27</option><option>28</option><option>29</option><option>30</option><option>31</option>", 32)
const _hoisted_79 = [
  _hoisted_47
]
const _hoisted_80 = {
  key: 0,
  class: "text-sm text-gray-400"
}
const _hoisted_81 = {
  key: 0,
  class: "text-xs text-pink-600"
}
const _hoisted_82 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("label", {
  for: "last-name",
  class: "block text-sm font-medium text-gray-700"
}, "戒名・法名", -1)
const _hoisted_84 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("label", {
  for: "last-name",
  class: "block text-sm font-medium text-gray-700"
}, "戒名・法名(カナ)", -1)
const _hoisted_86 = {
  key: 0,
  class: "text-xs text-pink-600"
}
const _hoisted_87 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_88 = { class: "col-span-4 flex flex-col" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("label", { class: "block px-2 text-sm font-medium text-gray-700" }, "歿年月日", -1)
const _hoisted_90 = { class: "flex items-center" }
const _hoisted_91 = /*#__PURE__*/_createStaticVNode("<option></option><option>01</option><option>02</option><option>03</option><option>04</option><option>05</option><option>06</option><option>07</option><option>08</option><option>09</option><option>10</option><option>11</option><option>12</option>", 13)
const _hoisted_104 = [
  _hoisted_91
]
const _hoisted_105 = /*#__PURE__*/_createStaticVNode("<option></option><option>01</option><option>02</option><option>03</option><option>04</option><option>05</option><option>06</option><option>07</option><option>08</option><option>09</option><option>10</option><option>11</option><option>12</option><option>13</option><option>14</option><option>15</option><option>16</option><option>17</option><option>18</option><option>19</option><option>20</option><option>21</option><option>22</option><option>23</option><option>24</option><option>25</option><option>26</option><option>27</option><option>28</option><option>29</option><option>30</option><option>31</option>", 32)
const _hoisted_137 = [
  _hoisted_105
]
const _hoisted_138 = {
  key: 0,
  class: "text-sm text-gray-400"
}
const _hoisted_139 = {
  key: 0,
  class: "text-xs text-pink-600"
}
const _hoisted_140 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_141 = /*#__PURE__*/_createElementVNode("label", {
  for: "last-name",
  class: "block text-sm font-medium text-gray-700"
}, "享年・行年", -1)
const _hoisted_142 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("label", {
  for: "last-name",
  class: "block text-sm font-medium text-gray-700"
}, "享年・行年の選択", -1)
const _hoisted_144 = { class: "flex" }
const _hoisted_145 = { class: "relative flex items-start" }
const _hoisted_146 = { class: "flex h-5 items-center" }
const _hoisted_147 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3 text-sm" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "kyonen",
    class: "font-medium text-gray-700"
  }, "享年")
], -1)
const _hoisted_148 = { class: "ml-4 relative flex items-start" }
const _hoisted_149 = { class: "flex h-5 items-center" }
const _hoisted_150 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3 text-sm" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "gyonen",
    class: "font-medium text-gray-700"
  }, "行年")
], -1)
const _hoisted_151 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_152 = /*#__PURE__*/_createElementVNode("label", {
  for: "last-name",
  class: "block text-sm font-medium text-gray-700"
}, "喪主", -1)
const _hoisted_153 = {
  key: 1,
  class: "mt-4 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6"
}
const _hoisted_154 = { class: "md:grid md:grid-cols-3 md:gap-6" }
const _hoisted_155 = { class: "mt-5 md:mt-0 md:col-span-2" }
const _hoisted_156 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("label", {
  for: "last-name",
  class: "block text-sm font-medium text-gray-700"
}, "出身地", -1)
const _hoisted_158 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_159 = /*#__PURE__*/_createElementVNode("label", {
  for: "last-name",
  class: "block text-sm font-medium text-gray-700"
}, "生前の趣味", -1)
const _hoisted_160 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_161 = /*#__PURE__*/_createElementVNode("label", {
  for: "last-name",
  class: "block text-sm font-medium text-gray-700"
}, "生前の学校", -1)
const _hoisted_162 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_163 = /*#__PURE__*/_createElementVNode("label", {
  for: "last-name",
  class: "block text-sm font-medium text-gray-700"
}, "生前の勤務先", -1)
const _hoisted_164 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_165 = /*#__PURE__*/_createElementVNode("label", {
  for: "last-name",
  class: "block text-sm font-medium text-gray-700"
}, "生前の勤務先", -1)
const _hoisted_166 = {
  key: 2,
  class: "mt-4 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6"
}
const _hoisted_167 = { class: "flex justify-end" }
const _hoisted_168 = ["onClick"]
const _hoisted_169 = {
  key: 0,
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_170 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_171 = { class: "fixed z-10 inset-0 overflow-y-auto" }
const _hoisted_172 = { class: "flex items-center justify-center min-h-full p-4 text-center sm:p-0" }
const _hoisted_173 = { class: "relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-sm sm:w-full sm:p-6" }
const _hoisted_174 = { class: "flex justify-center items-center" }
const _hoisted_175 = /*#__PURE__*/_createElementVNode("div", { class: "grow" }, null, -1)
const _hoisted_176 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, "保存しました", -1)
const _hoisted_177 = /*#__PURE__*/_createElementVNode("div", { class: "grow" }, null, -1)

import AppHeader from "@/components/AppHeader.vue";
// import Customer from "../models/Customer";
// import Prefecture from "../models/Prefecture";
// import Decedent from "@/models/Decedent";
// import ValidationUtil from "@/utils/ValidationUtil";

import * as yup from "yup";
import { useField, useForm, FieldContext } from "vee-validate";
import Decedent from "@/models/Decedent";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { uuid } from "vue-uuid";

import { Auth, Storage } from "aws-amplify";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditDecedentProfileView',
  setup(__props) {

// import { Options, Vue } from "vue-class-component";
// import AddressUtil from "../utils/AddressUtil";

// import { Storage } from "aws-amplify";
// import { uuid } from "vue-uuid";

const store = useStore();
const route = useRoute();

const type = ref<string>('basic');

const formSchema = yup.object({
  selfie_image_url: yup.string().required("必須項目です"),
  family_name: yup.string(),
  given_name: yup.string(),
  family_name_kana: yup.string().kana(),
  given_name_kana: yup.string().kana(),
  nickname: yup.string().required("必須項目です"),
  buddist_name: yup.string(),
  buddist_name_kana: yup.string().kana(),
  date_of_birth_year: yup.string(),
  date_of_birth_month: yup.string(),
  date_of_birth_day: yup.string(),
  date_of_dead_year: yup.string(),
  date_of_dead_month: yup.string(),
  date_of_dead_day: yup.string(),
  age: yup.string(),
  chief_mourner: yup.string(),
  birthplace: yup.string(),
  hobby: yup.string(),
  school: yup.string(),
  job: yup.string(),
  conferment: yup.string(),
});

useForm({ validationSchema: formSchema });

const selfie_image_url_field = useField<string>("main_image_url");
const family_name_field = useField<string>("family_name");
const given_name_field = useField<string>("given_name");
const family_name_kana_field = useField<string>("family_name_kana");
const given_name_kana_field = useField<string>("given_name_kana");
const nickname_field = useField<string>("nickname");
const buddist_name_field = useField<string>("buddist_name");
const buddist_name_kana_field = useField<string>("buddist_name_kana");
const date_of_birth_year_field = useField<string>("date_of_birth_year");
const date_of_birth_month_field = useField<string>("date_of_birth_month");
const date_of_birth_day_field = useField<string>("date_of_birth_day");
const date_of_dead_year_field = useField<string>("date_of_dead_year");
const date_of_dead_month_field = useField<string>("date_of_dead_month");
const date_of_dead_day_field = useField<string>("date_of_dead_day");
const age_field = useField<string>("age");
const chief_mourner_field = useField<string>("chief_mourner");
const birthplace_field = useField<string>("birthplace");
const hobby_field = useField<string>("hobby");
const school_field = useField<string>("school");
const job_field = useField<string>("job");
const conferment_field = useField<string>("conferment");

//     return {
const selfie_image_url = selfie_image_url_field.value;
const selfie_image_url_error = selfie_image_url_field.errorMessage;

const family_name = family_name_field.value;
const family_name_error = family_name_field.errorMessage;

const given_name = given_name_field.value;
const given_name_error = given_name_field.errorMessage;

const family_name_kana = family_name_kana_field.value;
const family_name_kana_error = family_name_kana_field.errorMessage;

const given_name_kana = given_name_kana_field.value;
const given_name_kana_error = given_name_kana_field.errorMessage;

const nickname = nickname_field.value;
const nickname_error = nickname_field.errorMessage;

const buddist_name = buddist_name_field.value;
const buddist_name_error = buddist_name_field.errorMessage;

const buddist_name_kana = buddist_name_kana_field.value;
const buddist_name_kana_error = buddist_name_kana_field.errorMessage;

const date_of_birth_year = date_of_birth_year_field.value;
const date_of_birth_year_error = date_of_birth_year_field.errorMessage;

const date_of_birth_month = date_of_birth_month_field.value;
const date_of_birth_month_error = date_of_birth_month_field.errorMessage;

const date_of_birth_day = date_of_birth_day_field.value;
const date_of_birth_day_error = date_of_birth_day_field.errorMessage;

const date_of_birth_error = computed<string>(() => {
  if (date_of_birth_year_error.value) {
    return date_of_birth_year_error.value;
  }
  if (date_of_birth_year_error.value) {
    return date_of_birth_year_error.value;
  }
  if (date_of_birth_year_error.value) {
    return date_of_birth_year_error.value;
  }
  return "";
});

const date_of_dead_year = date_of_dead_year_field.value;
const date_of_dead_year_error = date_of_dead_year_field.errorMessage;

const date_of_dead_month = date_of_dead_month_field.value;
const date_of_dead_month_error = date_of_dead_month_field.errorMessage;

const date_of_dead_day = date_of_dead_day_field.value;
const date_of_dead_day_error = date_of_dead_day_field.errorMessage;

const date_of_dead_error = computed<string>(() => {
  if (date_of_dead_year_error.value) {
    return date_of_dead_year_error.value;
  }
  if (date_of_dead_year_error.value) {
    return date_of_dead_year_error.value;
  }
  if (date_of_dead_year_error.value) {
    return date_of_dead_year_error.value;
  }
  return "";
});

const age = age_field.value;
const age_error = age_field.errorMessage;

const age_of_dead_type = ref<string>('kyonen');

const chief_mourner = chief_mourner_field.value;
const chief_mourner_error = chief_mourner_field.errorMessage;

const birthplace = birthplace_field.value;
const birthplace_error = birthplace_field.errorMessage;

const hobby = hobby_field.value;
const hobby_error = hobby_field.errorMessage;

const school = school_field.value;
const school_error = school_field.errorMessage;

const job = job_field.value;
const job_error = job_field.errorMessage;

const conferment = conferment_field.value;
const conferment_error = conferment_field.errorMessage;

const decedent = ref<Decedent>({} as Decedent);
const show_confirm = ref<boolean>(false);

const decedentId = (): string => {
  return route.params.decedent_id as string;
};

const refresh = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      decedent.value = await Decedent.get(decedentId());
      selfie_image_url.value = decedent.value.selfie_image_url ?? "";
      family_name.value = decedent.value.family_name ?? "";
      family_name_kana.value = decedent.value.family_name_kana ?? "";
      given_name.value = decedent.value.given_name ?? "";
      given_name_kana.value = decedent.value.given_name_kana ?? "";
      nickname.value = decedent.value.nickname ?? "";

      date_of_birth_year.value = "";
      date_of_birth_month.value = "";
      date_of_birth_day.value = "";

      if (decedent.value.date_of_birth) {
        const dy = decedent.value.date_of_birth.split("年")[0];
        const dm = decedent.value.date_of_birth.split("年")[1].split("月")[0];
        const dd = decedent.value.date_of_birth
          .split("年")[1]
          .split("月")[1]
          .split("日")[0];
        date_of_birth_year.value = dy;
        date_of_birth_month.value = dm;
        date_of_birth_day.value = dd;
      }

      buddist_name.value = decedent.value.buddist_name ?? "";
      buddist_name_kana.value = decedent.value.buddist_name_kana ?? "";

      date_of_dead_year.value = "";
      date_of_dead_month.value = "";
      date_of_dead_day.value = "";

      if (decedent.value.date_of_birth) {
        const dy = decedent.value.date_of_birth.split("年")[0];
        const dm = decedent.value.date_of_birth.split("年")[1].split("月")[0];
        const dd = decedent.value.date_of_birth
          .split("年")[1]
          .split("月")[1]
          .split("日")[0];
        date_of_birth_year.value = dy;
        date_of_birth_month.value = dm;
        date_of_birth_day.value = dd;
      }

      if (decedent.value.date_of_dead) {
        const dy = decedent.value.date_of_dead.split("年")[0];
        const dm = decedent.value.date_of_dead.split("年")[1].split("月")[0];
        const dd = decedent.value.date_of_dead
          .split("年")[1]
          .split("月")[1]
          .split("日")[0];
        date_of_dead_year.value = dy;
        date_of_dead_month.value = dm;
        date_of_dead_day.value = dd;
      }

      age.value = decedent.value.age ?? "";
      age_of_dead_type.value = decedent.value.age_of_dead_type ?? "kyonen";
      chief_mourner.value = decedent.value.chief_mourner ?? "";
      birthplace.value = decedent.value.birthplace ?? "";
      hobby.value = decedent.value.hobby ?? "";
      school.value = decedent.value.school ?? "";
      job.value = decedent.value.job ?? "";
      conferment.value = decedent.value.conferment ?? "";
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const setType = (t: string) => {
  type.value = t;
};

const selfie_image_url_input = ref<HTMLInputElement>();

const selectImage = () => {
  const input = selfie_image_url_input.value;
  input?.click();
};

const onFileChanged = () => {
  const input = selfie_image_url_input.value;
  if (!input?.files) {
    return;
  }
  const file = input.files[0];
  const split = file.name.split(".");
  const filename = uuid.v4();
  const extension = split[split.length - 1];
  const contentType = extension == "png" ? "image/png" : "image/jpg";

  setTimeout(async () => {
    Storage.configure({ customPrefix: { public: "decedents" } });
    const s3response = await Storage.put(`/${filename}.${extension}`, file, {
      contentType: contentType,
    });

    // console.log(s3response);

    selfie_image_url.value = `${process.env.VUE_APP_HOST}/decedents/${filename}.${extension}`;
    // console.log(selfie_image_url);
  });
};

const validate = async (): Promise<boolean> => {
  await selfie_image_url_field.validate();
  await family_name_field.validate();
  await given_name_field.validate();
  await family_name_kana_field.validate();
  await given_name_kana_field.validate();
  await nickname_field.validate();
  await buddist_name_field.validate();
  await buddist_name_kana_field.validate();
  await date_of_birth_year_field.validate();
  await date_of_birth_month_field.validate();
  await date_of_birth_day_field.validate();
  await date_of_dead_year_field.validate();
  await date_of_dead_month_field.validate();
  await date_of_dead_day_field.validate();
  await age_field.validate();
  await chief_mourner_field.validate();
  await birthplace_field.validate();
  await hobby_field.validate();
  await school_field.validate();
  await job_field.validate();
  await conferment_field.validate();

  return (
    !selfie_image_url_error.value &&
    !family_name_error.value &&
    !given_name_error.value &&
    !family_name_kana_error.value &&
    !given_name_kana_error.value &&
    !nickname_error.value &&
    !buddist_name_error.value &&
    !buddist_name_kana_error.value &&
    !date_of_birth_year_error.value &&
    !date_of_birth_month_error.value &&
    !date_of_birth_day_error.value &&
    !date_of_dead_year_error.value &&
    !date_of_dead_month_error.value &&
    !date_of_dead_day_error.value &&
    !age_error.value &&
    !chief_mourner_error.value &&
    !birthplace_error.value &&
    !hobby_error.value &&
    !school_error.value &&
    !job_error.value &&
    !conferment_error.value
  );
};

const doSave = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      if (!store.state.customer) {
        return;
      }

      const valid = await validate();
      if (!valid) {
        return;
      }

      let dob = "";

      if (
        date_of_birth_year.value &&
        date_of_birth_month.value &&
        date_of_birth_day.value
      ) {
        dob = `${date_of_birth_year.value}年${date_of_birth_month.value}月${date_of_birth_day.value}日`;
      }

      let dod = "";

      if (
        date_of_dead_year.value &&
        date_of_dead_month.value &&
        date_of_dead_day.value
      ) {
        dod = `${date_of_dead_year.value}年${date_of_dead_month.value}月${date_of_dead_day.value}日`;
      }

      await Decedent.update(
        decedentId(),
        selfie_image_url.value,
        family_name.value,
        given_name.value,
        family_name_kana.value,
        given_name_kana.value,
        nickname.value,
        buddist_name.value,
        buddist_name_kana.value,
        dob,
        dod,
        age.value,
        age_of_dead_type.value,
        "",
        birthplace.value,
        hobby.value,
        school.value,
        job.value,
        conferment.value
      );

      store.dispatch("refreshUser");

      show_confirm.value = true;
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

onMounted(() => {
  refresh();
});

return (_ctx: any,_cache: any) => {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("nav", _hoisted_4, [
              _createElementVNode("a", {
                href: "javascript:void(0)",
                class: _normalizeClass(["border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 w-1/2 py-4 px-1 text-center border-b-2 font-medium text-sm", {
                'border-color-2': type.value == 'basic',
                'text-color-2': type.value == 'basic',
                'border-b-2': type.value == 'basic',
              }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (setType('basic')))
              }, " 基本情報 ", 2),
              (!decedent.value?.is_celebrity)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "javascript:void(0)",
                    class: _normalizeClass(["border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 w-1/2 py-4 px-1 text-center border-b-2 font-medium text-sm", {
                'border-color-2': type.value == 'advance',
                'text-color-2': type.value == 'advance',
                'border-b-2': type.value == 'advance',
              }]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (setType('advance')))
                  }, " 生前の情報 ", 2))
                : _createCommentVNode("", true),
              _createElementVNode("a", {
                href: "javascript:void(0)",
                class: _normalizeClass(["border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 w-1/2 py-4 px-1 text-center border-b-2 font-medium text-sm", {
                'border-color-2': type.value == 'setting',
                'text-color-2': type.value == 'setting',
                'border-b-2': type.value == 'setting',
              }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (setType('setting')))
              }, " 設定 ", 2)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (type.value == 'basic')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_9, [
                        (!_unref(selfie_image_url))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _hoisted_12))
                          : _createCommentVNode("", true),
                        (_unref(selfie_image_url))
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: _unref(selfie_image_url),
                              class: "inline-block h-12 w-12 rounded-full overflow-hidden bg-gray-100"
                            }, null, 8, _hoisted_13))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          class: "bg-white py-2 px-3 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700",
                          onClick: selectImage
                        }, " 変更 "),
                        _createElementVNode("input", {
                          ref_key: "selfie_image_url_input",
                          ref: selfie_image_url_input,
                          type: "file",
                          style: {"display":"none"},
                          accept: "image/png, image/jpeg",
                          onChange: onFileChanged
                        }, null, 544)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "first-name",
                          id: "first-name",
                          class: "mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(family_name) ? (family_name).value = $event : null))
                        }, null, 512), [
                          [_vModelText, _unref(family_name)]
                        ]),
                        (_unref(family_name_error))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(family_name_error) || ""), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "last-name",
                          id: "last-name",
                          class: "mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(given_name) ? (given_name).value = $event : null))
                        }, null, 512), [
                          [_vModelText, _unref(given_name)]
                        ]),
                        (_unref(given_name_error))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(given_name_error) || ""), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "first-name",
                          id: "first-name",
                          class: "mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(family_name_kana) ? (family_name_kana).value = $event : null))
                        }, null, 512), [
                          [_vModelText, _unref(family_name_kana)]
                        ]),
                        (_unref(family_name_kana_error))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_unref(family_name_kana_error) || ""), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "last-name",
                          id: "last-name",
                          class: "mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(given_name_kana) ? (given_name_kana).value = $event : null))
                        }, null, 512), [
                          [_vModelText, _unref(given_name_kana)]
                        ]),
                        (_unref(given_name_kana_error))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_unref(given_name_kana_error) || ""), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "last-name",
                          id: "last-name",
                          class: "mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(nickname) ? (nickname).value = $event : null))
                        }, null, 512), [
                          [_vModelText, _unref(nickname)]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _hoisted_31,
                          _createElementVNode("div", _hoisted_32, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: _normalizeClass(["mt-1 block w-24 shadow-sm sm:text-sm border-gray-300 rounded-md", {
                          'border-gray-300': !date_of_birth_error.value,
                          'border-red-300': !!date_of_birth_error.value,
                        }]),
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(date_of_birth_year) ? (date_of_birth_year).value = $event : null))
                            }, null, 2), [
                              [_vModelText, _unref(date_of_birth_year)]
                            ]),
                            _createTextVNode(" 年 "),
                            _withDirectives(_createElementVNode("select", {
                              class: _normalizeClass(["mt-1 block w-18 shadow-sm sm:text-sm border-gray-300 rounded-md", {
                          'border-gray-300': !date_of_birth_error.value,
                          'border-red-300': !!date_of_birth_error.value,
                        }]),
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(date_of_birth_month) ? (date_of_birth_month).value = $event : null))
                            }, _hoisted_46, 2), [
                              [_vModelSelect, _unref(date_of_birth_month)]
                            ]),
                            _createTextVNode(" 月 "),
                            _withDirectives(_createElementVNode("select", {
                              class: _normalizeClass(["mt-1 block w-18 shadow-sm sm:text-sm border-gray-300 rounded-md", {
                          'border-gray-300': !date_of_birth_error.value,
                          'border-red-300': !!date_of_birth_error.value,
                        }]),
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(date_of_birth_day) ? (date_of_birth_day).value = $event : null))
                            }, _hoisted_79, 2), [
                              [_vModelSelect, _unref(date_of_birth_day)]
                            ]),
                            _createTextVNode(" 日 ")
                          ]),
                          (!date_of_birth_error.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_80, "例) 1952 昭和25 BC100"))
                            : _createCommentVNode("", true)
                        ]),
                        (date_of_birth_error.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_81, _toDisplayString(date_of_birth_error.value || ""), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_82, [
                        _hoisted_83,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "last-name",
                          id: "last-name",
                          class: "mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(buddist_name) ? (buddist_name).value = $event : null))
                        }, null, 512), [
                          [_vModelText, _unref(buddist_name)]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_84, [
                        _hoisted_85,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "last-name",
                          id: "last-name",
                          class: "mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(buddist_name_kana) ? (buddist_name_kana).value = $event : null))
                        }, null, 512), [
                          [_vModelText, _unref(buddist_name_kana)]
                        ]),
                        (_unref(buddist_name_kana_error))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_86, _toDisplayString(_unref(buddist_name_kana_error) || ""), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("div", _hoisted_88, [
                          _hoisted_89,
                          _createElementVNode("div", _hoisted_90, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: _normalizeClass(["mt-1 block w-24 shadow-sm sm:text-sm border-gray-300 rounded-md", {
                          'border-gray-300': !date_of_dead_error.value,
                          'border-red-300': !!date_of_dead_error.value,
                        }]),
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(date_of_dead_year) ? (date_of_dead_year).value = $event : null))
                            }, null, 2), [
                              [_vModelText, _unref(date_of_dead_year)]
                            ]),
                            _createTextVNode(" 年 "),
                            _withDirectives(_createElementVNode("select", {
                              class: _normalizeClass(["mt-1 block w-18 shadow-sm sm:text-sm border-gray-300 rounded-md", {
                          'border-gray-300': !date_of_dead_error.value,
                          'border-red-300': !!date_of_dead_error.value,
                        }]),
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_isRef(date_of_dead_month) ? (date_of_dead_month).value = $event : null))
                            }, _hoisted_104, 2), [
                              [_vModelSelect, _unref(date_of_dead_month)]
                            ]),
                            _createTextVNode(" 月 "),
                            _withDirectives(_createElementVNode("select", {
                              class: _normalizeClass(["mt-1 block w-18 shadow-sm sm:text-sm border-gray-300 rounded-md", {
                          'border-gray-300': !date_of_dead_error.value,
                          'border-red-300': !!date_of_dead_error.value,
                        }]),
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_isRef(date_of_dead_day) ? (date_of_dead_day).value = $event : null))
                            }, _hoisted_137, 2), [
                              [_vModelSelect, _unref(date_of_dead_day)]
                            ]),
                            _createTextVNode(" 日 ")
                          ]),
                          (!date_of_dead_error.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_138, "例) 1952 昭和25 BC100"))
                            : _createCommentVNode("", true)
                        ]),
                        (date_of_dead_error.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_139, _toDisplayString(date_of_dead_error.value || ""), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_140, [
                        _hoisted_141,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_isRef(age) ? (age).value = $event : null))
                        }, null, 512), [
                          [_vModelText, _unref(age)]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_142, [
                        _hoisted_143,
                        _createElementVNode("div", _hoisted_144, [
                          _createElementVNode("div", _hoisted_145, [
                            _createElementVNode("div", _hoisted_146, [
                              _withDirectives(_createElementVNode("input", {
                                id: "kyonen",
                                type: "radio",
                                class: "h-4 w-4 rounded border-gray-300 text-gray-600",
                                value: "kyonen",
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((age_of_dead_type).value = $event))
                              }, null, 512), [
                                [_vModelRadio, age_of_dead_type.value]
                              ])
                            ]),
                            _hoisted_147
                          ]),
                          _createElementVNode("div", _hoisted_148, [
                            _createElementVNode("div", _hoisted_149, [
                              _withDirectives(_createElementVNode("input", {
                                id: "gyonen",
                                type: "radio",
                                class: "h-4 w-4 rounded border-gray-300 text-gray-600",
                                value: "gyonen",
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((age_of_dead_type).value = $event))
                              }, null, 512), [
                                [_vModelRadio, age_of_dead_type.value]
                              ])
                            ]),
                            _hoisted_150
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_151, [
                        _hoisted_152,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_isRef(chief_mourner) ? (chief_mourner).value = $event : null))
                        }, null, 512), [
                          [_vModelText, _unref(chief_mourner)]
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (type.value == 'advance')
            ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
                _createElementVNode("div", _hoisted_154, [
                  _createElementVNode("div", _hoisted_155, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_156, [
                        _hoisted_157,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_isRef(birthplace) ? (birthplace).value = $event : null))
                        }, null, 512), [
                          [_vModelText, _unref(birthplace)]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_158, [
                        _hoisted_159,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_isRef(hobby) ? (hobby).value = $event : null))
                        }, null, 512), [
                          [_vModelText, _unref(hobby)]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_160, [
                        _hoisted_161,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_isRef(school) ? (school).value = $event : null))
                        }, null, 512), [
                          [_vModelText, _unref(school)]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_162, [
                        _hoisted_163,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_isRef(job) ? (job).value = $event : null))
                        }, null, 512), [
                          [_vModelText, _unref(job)]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_164, [
                        _hoisted_165,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_isRef(conferment) ? (conferment).value = $event : null))
                        }, null, 512), [
                          [_vModelText, _unref(conferment)]
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (type.value == 'setting')
            ? (_openBlock(), _createElementBlock("div", _hoisted_166))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_167, [
            _createElementVNode("button", {
              type: "submit",
              class: "ml-3 mb-4 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-color-2",
              onClick: _withModifiers(doSave, ["prevent"])
            }, " 保存 ", 8, _hoisted_168)
          ])
        ])
      ])
    ]),
    (show_confirm.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_169, [
          _hoisted_170,
          _createElementVNode("div", _hoisted_171, [
            _createElementVNode("div", _hoisted_172, [
              _createElementVNode("div", _hoisted_173, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_174, [
                    _hoisted_175,
                    _hoisted_176,
                    _hoisted_177,
                    _createElementVNode("button", {
                      class: "ml-8 flex items-center justify-center h-8 w-8 rounded-full",
                      onClick: _cache[25] || (_cache[25] = ($event: any) => (show_confirm.value = false))
                    }, [
                      _createVNode(_component_fa, { icon: "times" })
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})